import React, { useContext } from 'react';
import { connect } from 'react-redux';

// components
import {
  Type,
  Button,
  Typography,
  Icon,
  FontType,
  Color,
  Size
} from '@americanexpress/aqx-components';
// selectors
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import {
  makeGetHighlights,
  makeGetQuickViewItems,
  makeGetFeaturedBenefits,
  makeGetRate,
  makeGetExtendedTilesData
} from 'page_modules/business-vac/components/CardTileDesktop/redux';
import { G172QuickViewContext } from './Tile';
// utiles
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';

// styles
import styles from '../__styles__/Desktop.scss?modules';

const formatHeader = (benefitItem = {}, featuredBenefitItem = {}) => {
  const { header, title, flag } = benefitItem;
  const { text } = featuredBenefitItem;

  const flagString = flag ? `<span class=${styles.flag}>${flag}</span>` : '';
  if (header || title || text) {
    return `${header || title || text}${flagString}`;
  }

  return '';
};

const CollapsedBenefitItem = ({ collapsedBenefit, featuredBenefitItem, rate }) => {
  return (
    <li className={styles.collapsedBenefitItem} key={collapsedBenefit.text}>
      <Icon
        directory="dls"
        imageName={
          collapsedBenefit.header
            ? collapsedBenefit.icon
            : featuredBenefitItem?.icon || collapsedBenefit.icon || ''
        }
        className={styles.icon}
      />
      <div className={styles.textAndFlag}>
        <Sanitizer
          className={styles.header}
          Component="b"
          safelySetInnerHTML={formatHeader(collapsedBenefit, featuredBenefitItem)}
        />
        <Typography className={styles.text} $size={15} $lineHeight={22}>
          {collapsedBenefit.header ? rate : collapsedBenefit.text}
        </Typography>
        {collapsedBenefit.flag && (
          <span className={styles.flag}>{collapsedBenefit.flag}</span>
        )}
      </div>
    </li>
  );
};

const CardBenefits = ({
  benefits,
  tileData,
  shortName,
  header,
  collapsedBenefits,
  featuredBenefits,
  aprRate
}) => {
  const { setIsQuickViewOpen, isQuickViewOpen } = useContext(G172QuickViewContext);
  const buttons = tileData?.buttons || {};

  const drawerCta = isQuickViewOpen ? buttons.hideBenefits : buttons?.showBenefits;

  return (
    <div className={styles.benefitscontainer}>
      <div className={styles.g172BenefitsCtaWrapper}>
        <Typography
          Component="h3"
          $size="16px"
          $lineHeight="24px"
          $family={FontType.HelveticaRegular}
          className={styles.header}
          theme={{
            color: Color.DeepBlue
          }}
        >
          {header}
        </Typography>

        <Button
          $type={Type.Tertiary}
          onClick={() => {
            setIsQuickViewOpen(!isQuickViewOpen);
            sendDTMClickEvent({
              ...drawerCta?.dtm,
              eventAsset: `${drawerCta?.dtm?.eventAsset}${shortName}`
            });
          }}
          className={styles.drawerCta}
        >
          <Typography
            $size="16px"
            $lineHeight="24px"
            $family={FontType.HelveticaRegular}
            theme={{
              color: Color.BrightBlue
            }}
          >
            {drawerCta?.text}
          </Typography>
          <Icon
            directory="dls"
            imageName={`dls-icon-${isQuickViewOpen ? 'up' : 'down'}`}
            $size={Size.MD}
            theme={{
              marginTop: 5,
              marginLeft: 10
            }}
          />
        </Button>
      </div>
      {!isQuickViewOpen ? (
        <ul className={styles.defaultBenefit}>
          {benefits.map(benefit => {
            return (
              <li key={benefit.text}>
                <Icon
                  directory="dls"
                  imageName={benefit.icon.imageName}
                  className={styles.icon}
                />
                <div className={styles.textAndFlag}>
                  <Typography className={styles.text} $size={15} $lineHeight={22}>
                    {benefit.text}
                  </Typography>
                  {benefit.flag && (
                    <span className={styles.flag}>{benefit.flag}</span>
                  )}
                </div>
              </li>
            );
          })}
        </ul>
      ) : (
        <ul className={styles.collapsedBenefits}>
          {collapsedBenefits.map((item, i) => (
            <CollapsedBenefitItem
              collapsedBenefit={item}
              featuredBenefitItem={featuredBenefits?.[i]}
              rate={aprRate}
              key={i}
            />
          ))}
        </ul>
      )}
    </div>
  );
};

const mapStateToProps = () => {
  const getBenefits = makeGetHighlights();
  const getcollapsedBenefits = makeGetQuickViewItems();
  const getFeaturedBenefits = makeGetFeaturedBenefits();
  const getRate = makeGetRate();
  const getCardTileData = makeGetExtendedTilesData();

  return (state, { shortName }) => ({
    benefits: getBenefits(state, shortName),
    tileData: getCardTileData(state),
    featuredBenefits: getFeaturedBenefits(state, shortName),
    collapsedBenefits: getcollapsedBenefits(state, shortName),
    aprRate: getRate(state, shortName),

    shortName
  });
};

export default connect(mapStateToProps)(CardBenefits);
